import React from 'react';
import WHStep3 from './WHStep3';

export default function WHStep3Container({ whAppData, formikProp }) {
  return <WHStep3 whAppData={whAppData} formikProp={formikProp} />;
}
